import {match} from 'ts-pattern';

interface ChartDataPoint {
  price: number;
}

interface ChartDomain {
  min: number;
  max: number;
}

const getCurrencyDivisor = (currency: string) =>
  match(currency)
    .with('CZK', () => 1000)
    .otherwise(() => 100);

export function calculateChartDomain(chartData: ChartDataPoint[], currency: string): ChartDomain {
  const prices = chartData.map((item) => item.price);
  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);
  const divisor = getCurrencyDivisor(currency);
  const roundedMin = Math.floor(minPrice / divisor) * divisor;
  const roundedMax = Math.ceil(maxPrice / divisor) * divisor;

  return {
    min: roundedMin,
    max: roundedMax,
  };
}
